import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePrompts() {
  const [prompts, setPrompts] = useState(null);

  const [shouldRefetch, setRefresh] = useState({});

  const refresh = () => {
    setRefresh({});
  };

  useEffect(() => {
    axios
      .get(routes.api.super_admins.prompts.index)
      .then((response) => {
        setPrompts(response.data.data);
      });
  }, [shouldRefetch]);

  return { prompts, refresh };
}
